import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { DocusignService } from './docusign.service';
import { SnackbarService } from "../shared/services/snackbar.service";

@Component({
    template: require('./docusign.component.html'),
    styles: [require('./docusign.component.less')],
    providers: [DocusignService, SnackbarService],
    preserveWhitespaces: true
})

export class DocusignComponent implements OnInit {
    
    apiSubscription: Subscription;
    
    constructor(
        private _router: Router,
        private _docusignService: DocusignService,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
    ) {

    }
    ngOnInit() {
        this._activatedRoute.queryParams.subscribe((params: Params) => {
            let codeData: any = {};

            codeData.code = params['code'];
            this.apiSubscription = this._docusignService.sendDocuSignAuth(codeData).
                subscribe((res: any) => this.docusignSuccessHandler(res),
                error => this.docusignErrorHandler(error));
        });
    }

    // on docusign success
    docusignSuccessHandler(res: any) {
        this._mdlSnackbarService.showSnackbar('DOCUSIGN_LINK_SUCCESS', 'success');
        this._router.navigate(['pa-settings/payment-options']);
    }

    // on docusign failure
    docusignErrorHandler(error: any) {
        this._mdlSnackbarService.showSnackbar('DOCUSIGN_LINK_ERROR', 'error');
        this._router.navigate(['pa-settings/payment-options']);
    }

    ngOnDestroy() {
        this.apiSubscription?.unsubscribe();
    }
    
}